import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, QuestionBody, QuestionResponse } from 'src/app/shared/models/questionnaire.model';

@Component({
    selector: 'app-chapter-questions',
    templateUrl: './chapter-questions.component.html',
    styleUrl: './chapter-questions.component.scss',
    standalone: false
})
export class ChapterQuestionsComponent implements OnInit {
	@Input() question!: Question;
	@Input() questionID!: string;
	@Input() themeList: string[] = [];
	@Output() questionError = new EventEmitter();

	time_limit_tooltip = 'Number of seconds before the system will move automatically to the next question.';
	count_down_tooltip = 'Number of seconds before the system will show a count down to alert the user that time limit is almost there.';
	record_sec_tooltip = 'Number of seconds for max time of voice recording.';
	auto_recording_tooltip = 'Number of seconds before the system will start voice recording automatically.';
	count_down_auto_recording_tooltip = 'Number of seconds before the system will show a count down to alert the user that the voice recording will start automaticaly.';
	
	responseTypesList = ['VISUAL', 'SELECT', 'RANGE', 'VOICE'];
	thresholdList = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
	linkTypes = ['VIDEO', 'AUDIO'];

	responseType: string | null = null;
	option: string | null = null;
	optionIndex: any = null;

	oldMax!: number;
	oldMin!: number;
	oldLabelMax!: string;
	oldLabelMin!: string;

	optionError = false;
	optionSubmit = false;
	submittedQuestion = false;
	submitted = false;
	spinner = false;
	editOptionMode = false;

	constructor() {}

	ngOnInit(): void {
		this.responseType = this.question.response.response_type;
		if (this.responseType) {
			if (this.responseType === 'RANGE') {
				if (this.question.response.response_range) {
					this.oldMin = this.question.response.response_range.range_min;
					this.oldMax = this.question.response.response_range.range_max;

					this.oldLabelMin = this.question.response.response_range.range_label_min;
					this.oldLabelMax = this.question.response.response_range.range_label_max;
				}
			}
		}

		if (this.question.status === 'error') {
			this.submitted = true;
		}
	}

	increment(value: string) {
		switch (value) {
			case 'time_limit':
				this.question.time_limit++;
				break;
			case 'count_down':
				this.question.count_down++;
				break;
			case 'voice_record_sec':
				if (this.question.response.response_voice) {
					this.question.response.response_voice.record_sec++;
				}
				break;
			case 'voice_time_to_start':
				if (this.question.response.response_voice) {
					this.question.response.response_voice.time_to_start++;
				}
				break;
			case 'voice_alert_before':
				if (this.question.response.response_voice) {
					this.question.response.response_voice.alert_before++;
				}
				break;
			default:
				break;
		}
  }

  decrement(value: string) {
    switch (value) {
			case 'time_limit':
				if (this.question.time_limit > 0) {
					this.question.time_limit--;
				}
				break;
			case 'count_down':
				if (this.question.count_down > 0) {
					this.question.count_down--;
				}
				break;
			case 'voice_record_sec':
				if (this.question.response.response_voice) {
					if (this.question.response.response_voice.record_sec > 0) {
						this.question.response.response_voice.record_sec--;
					}
				}
				break;
			case 'voice_time_to_start':
				if (this.question.response.response_voice) {
					if (this.question.response.response_voice.time_to_start > 0) {
						this.question.response.response_voice.time_to_start--;
					}
				}
				break;
			case 'voice_alert_before':
				if (this.question.response.response_voice) {
					if (this.question.response.response_voice.alert_before > 0) {
						this.question.response.response_voice.alert_before--;
					}
				}
				break;
			default:
				break;
		}
  }

	addTheme(val: any) {
    return val;
  }

	reposponseTypeChange() {
		switch (this.question.response.response_type) {
			case 'SELECT':
				if (!this.question.response.response_select) {
					this.question.response.response_select = {
						multi_select: false,
						response_options: []
					}
				}
				break;
			case 'RANGE':
				if (!this.question.response.response_range) {
					this.question.response.response_range = {
						range_min: 1,
						range_max: 7,
						range_label_max: '',
						range_label_min: '',
						range_steps: 1
					}
				}
				break;
			case 'VOICE':
				if (!this.question.response.response_voice) {
					this.question.response.response_voice = {
						time_to_start: 5,
						record_sec: 10,
						alert_before: 5
					}
				}
				break;
		}
	}

	editOption(index: number) {
		this.optionSubmit = false;
		this.optionError = false;
		this.editOptionMode = true;
		this.optionIndex = index;

		if (this.question.response.response_select) {
			this.option = this.question.response.response_select.response_options[this.optionIndex].label;
		}
	}

	deleteOption(index: number) {
		if (this.question.response.response_select) {
			this.question.response.response_select.response_options.splice(index, 1);
		}
	}

	addEditOption() {
		this.optionSubmit = true;
		this.optionError = false;
		
		if (this.question.response.response_select) {
			if (this.option && this.option !== '') {
				if (this.editOptionMode) {
					this.question.response.response_select.response_options[this.optionIndex].label = this.option;
					this.editOptionMode = false;
				} else {
					this.question.response.response_select.response_options.push({ label: this.option });
				}

				this.optionSubmit = false;
				this.option = null;
			} else {
				this.optionError = true;
			}
		}
	}

	checkedMultiselect() {
		if (this.question.response.response_select) {
			this.question.response.response_select.multi_select = !this.question.response.response_select.multi_select;
		}
	}

	checkResponseTypeValidity(response: QuestionResponse): boolean {
		switch (response.response_type) {
			case 'SELECT':
				if (response.response_select) {
					if (response.response_select.response_options.length < 2) {
						return false;
					}
				}
				break;
			case 'RANGE':
				if (response.response_range) {
					if (response.response_range.range_min >= response.response_range.range_max) {
						return false;
					}

					if (!response.response_range.range_label_max || !response.response_range.range_label_min) {
						return false;
					}
				}
				break;
		}
		return true;
	}

	checkQuestionBodyValidity(body: QuestionBody): boolean {
		if ((body.question === '' || !body.question || body.question.length < 20) && !body.link_url) {
			return false;
		}

		return true;
	}
}
